import { DigitalFormBackgroundTheme } from '../api/types/digitalForms.api.types';

export const DigitalFormBackgroundThemeUrls = {
  [DigitalFormBackgroundTheme.Stationary]: 'https://storage.googleapis.com/ktech-public/form_background_leaves.jpg',
  [DigitalFormBackgroundTheme.Paws]: 'https://storage.googleapis.com/ktech-public/form_background_paw.jpg',
  [DigitalFormBackgroundTheme.PurpleAbstract]: 'https://storage.googleapis.com/ktech-public/form_background_purple.jpg',
  [DigitalFormBackgroundTheme.Mint]: 'https://storage.googleapis.com/ktech-public/form_background_mint.jpg',
} as const;

export const getThemeJson = (backgroundThemeId: DigitalFormBackgroundTheme) => ({
  backgroundImage: DigitalFormBackgroundThemeUrls[backgroundThemeId],
  backgroundImageFit: 'cover' as const,
  backgroundImageAttachment: 'scroll' as const,
  backgroundOpacity: 1,
  isPanelless: true,
  cssVariables: {
    '--sjs-general-backcolor': 'rgba(255, 255, 255, 1)',
    '--sjs-general-backcolor-dark': 'rgba(248, 248, 248, 1)',
    '--sjs-general-backcolor-dim': 'rgba(255, 255, 255, 1)',
    '--sjs-general-backcolor-dim-light': 'rgba(249, 249, 249, 0)',
    '--sjs-general-backcolor-dim-dark': 'rgba(243, 243, 243, 1)',
    '--sjs-general-forecolor': 'rgba(0, 0, 0, 0.91)',
    '--sjs-general-forecolor-light': 'rgba(0, 0, 0, 0.45)',
    '--sjs-general-dim-forecolor': 'rgba(0, 0, 0, 0.91)',
    '--sjs-general-dim-forecolor-light': 'rgba(0, 0, 0, 0.45)',
    '--sjs-primary-backcolor': 'rgba(0, 0, 0, 1)',
    '--sjs-primary-backcolor-light': 'rgba(0, 0, 0, 0.1)',
    '--sjs-primary-backcolor-dark': 'rgba(-15, -15, -15, 1)',
    '--sjs-primary-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-primary-forecolor-light': 'rgba(255, 255, 255, 0.25)',
    '--sjs-base-unit': '8px',
    '--sjs-corner-radius': '8px',
    '--sjs-secondary-backcolor': 'rgba(255, 152, 20, 1)',
    '--sjs-secondary-backcolor-light': 'rgba(255, 152, 20, 0.1)',
    '--sjs-secondary-backcolor-semi-light': 'rgba(255, 152, 20, 0.25)',
    '--sjs-secondary-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-secondary-forecolor-light': 'rgba(255, 255, 255, 0.25)',
    '--sjs-shadow-small': 'inset 0px 0px 0px 1px rgba(0, 0, 0, 0.2)',
    '--sjs-shadow-small-reset': 'inset 0px 0px 0px 0px rgba(0, 0, 0, 0.2)',
    '--sjs-shadow-medium': '0px 2px 6px 0px rgba(0, 0, 0, 0.1)',
    '--sjs-shadow-large': '0px 8px 16px 0px rgba(0, 0, 0, 0.1)',
    '--sjs-shadow-inner': '0px 1px 0px 0px rgba(0, 0, 0, 0.2)',
    '--sjs-shadow-inner-reset': '0px 0px 0px 0px rgba(0, 0, 0, 0.2)',
    '--sjs-border-light': 'rgba(0, 0, 0, 0.25)',
    '--sjs-border-default': 'rgba(0, 0, 0, 0.25)',
    '--sjs-border-inside': 'rgba(0, 0, 0, 0.16)',
    '--sjs-special-red': 'rgba(229, 10, 62, 1)',
    '--sjs-special-red-light': 'rgba(229, 10, 62, 0.1)',
    '--sjs-special-red-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-special-green': 'rgba(25, 179, 148, 1)',
    '--sjs-special-green-light': 'rgba(25, 179, 148, 0.1)',
    '--sjs-special-green-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-special-blue': 'rgba(67, 127, 217, 1)',
    '--sjs-special-blue-light': 'rgba(67, 127, 217, 0.1)',
    '--sjs-special-blue-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-special-yellow': 'rgba(255, 152, 20, 1)',
    '--sjs-special-yellow-light': 'rgba(255, 152, 20, 0.1)',
    '--sjs-special-yellow-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-font-size': '16px',
    '--font-family': 'Open Sans',
    '--sjs-font-editorfont-color': 'rgba(0, 0, 0, 1)',
    '--sjs-font-editorfont-placeholdercolor': 'rgba(0, 0, 0, 0.35)',
    '--sjs-font-surveytitle-size': '24px',
    '--sjs-font-pagetitle-color': 'rgba(0, 0, 0, 0.9)',
    '--sjs-font-questiontitle-color': 'rgba(0, 0, 0, 0.9)',
    '--sjs-font-pagedescription-color': '#262626',
    '--sjs-font-questiondescription-color': '#262626',
    '--sjs-header-backcolor': 'transparent',
    '--sjs-font-headerdescription-color': 'rgba(0, 0, 0, 0.9)',
    '--sjs-font-headerdescription-weight': '700',
    '--sjs-font-headerdescription-size': '14px',
    '--sjs-editor-background': 'rgba(249, 249, 249, 1)',
    '--sjs-editorpanel-backcolor': 'rgba(249, 249, 249, 0)',
    '--sjs-editorpanel-hovercolor': 'rgba(243, 243, 243, 1)',
    '--sjs-editorpanel-cornerRadius': '0px',
  },
  themeName: 'default',
  colorPalette: 'light',
  header: {
    height: 176,
    inheritWidthFrom: 'survey' as const,
    textAreaWidth: 360,
    overlapEnabled: false,
    backgroundImageOpacity: 1,
    backgroundImageFit: 'cover' as const,
    logoPositionX: 'right' as const,
    logoPositionY: 'middle' as const,
    titlePositionX: 'right' as const,
    titlePositionY: 'middle' as const,
    descriptionPositionX: 'right' as const,
    descriptionPositionY: 'middle' as const,
  },
  headerView: 'advanced' as const,
  questionErrorLocation: 'bottom',
  completeText: 'Sign',
  // questionsOnPageMode: 'singlePage',
  widthMode: 'static',
  width: '55%', // Desktop width - tablets handled by CSS
});
